module.exports = __webpack_public_path__ + "static/ansonkao-03b779431a85df06bda9c5c3e3a0984b.png";